<!-- Adapted from YesPlayMusic v0.4.11, MIT (qier222). views/newAlbum.vue -->
<template>
  <div class="newAlbum" :class="{'salt-catalog-page':salt}" :aria-busy="loading">
    <h1>新专速递</h1>
    <CatalogPlatform />
    <p v-if="loading && !albums.length" class="loading-state" role="status">正在加载新专辑…</p>
    <p v-if="error" class="error-state" role="status">{{ error }} <component :is="salt ? 'SaltButton' : 'button'" style-type="plain" :disabled="loading" @click="loadData(albums.length > 0)">重试</component></p>
    <div class="playlist-row">
      <div class="playlists">
        <CoverRow type="album" :items="albums" sub-text="artist" :gap="salt ? '16px' : '44px 24px'" :sub-text-font-size="salt ? '14px' : '16px'" :style="salt ? {gridTemplateColumns:'repeat(auto-fill,minmax(128px,1fr))'} : null" />
      </div>
    </div>
    <p v-if="!loading && !error && !albums.length" class="empty-state">来源暂未返回新专辑。</p>
    <div v-if="hasMore" class="load-more">
      <SaltButton v-if="salt" style-type="subtle" :disabled="loading" @click="loadData(true)">{{ loading ? '正在加载…' : '加载更多' }}</SaltButton><ButtonTwoTone v-else color="grey" :disabled="loading" @click.native="loadData(true)">{{ loading ? '正在加载…' : '加载更多' }}</ButtonTwoTone>
    </div>
  </div>
</template>

<script>
import { runtime } from '../bridge';
import CatalogPlatform from '../components/CatalogPlatform.vue';
import CoverRow from '../components/CoverRow.vue';
import ButtonTwoTone from '../components/ButtonTwoTone.vue';
import SaltButton from '../salt/ui/SaltButton.vue';
import {workspace} from '../workspace';

export default {
  name: 'NewAlbum',
  components: { CoverRow, ButtonTwoTone, CatalogPlatform, SaltButton },
  data() {
    return { workspace, catalogSettings: runtime.catalogSettings, albums: [], loading: false, error: '', hasMore: false, cursor: 0, request: 0 };
  },
  computed:{salt(){return this.workspace.appearance==='salt';}},
  created() {
    this.loadData();
  },
  watch: { 'catalogSettings.platform'() { this.request++; this.loading = false; this.albums = []; this.cursor = 0; this.hasMore = false; this.loadData(); } },
  beforeDestroy() {
    this.request += 1;
  },
  methods: {
    async loadData(append = false) {
      if (this.loading) return;
      const version = ++this.request;
      this.loading = true;
      this.error = '';
      try {
        const data = await runtime.catalog('albums', undefined, { area: 'EA', limit: 100, offset: append ? this.cursor : 0 });
        if (version !== this.request) return;
        if (!Array.isArray(data.albums)) throw new Error('专辑来源返回了无效数据，请重试。');
        const existing = new Set(this.albums.map(album => String(album.id)));
        const additions = data.albums.filter(album => !existing.has(String(album.id)));
        this.albums = append ? [...this.albums, ...additions] : data.albums;
        this.hasMore = Boolean(data.more) && additions.length > 0;
        this.cursor = data.nextCursor || this.albums.length;
      } catch (error) {
        if (version === this.request) this.error = error.message || '新专辑加载失败。';
      } finally {
        if (version === this.request) this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  color: var(--color-text);
  font-size: 56px;
}
.load-more {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
.salt-catalog-page h1 { margin:0;font-size:24px;font-weight:400;color:var(--salt-text); }
</style>
